import { axiosInstance, parseResponse, TENANT_API_URL } from "..";
import type { SerializedPushSubscription } from "@/pwa/push";

const PWA_URL = `${TENANT_API_URL}/pwa`;

export const getVapidPublicKey = async () => {
  try {
    return parseResponse(
      await axiosInstance.get(`${PWA_URL}/vapid-public-key`)
    ) as {
      success?: boolean;
      configured?: boolean;
      publicKey?: string | null;
      message?: string;
    };
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const savePushSubscription = async (
  subscription: SerializedPushSubscription
) => {
  try {
    return parseResponse(
      await axiosInstance.post(`${PWA_URL}/push-subscriptions`, subscription)
    );
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const deletePushSubscription = async (endpoint: string) => {
  try {
    return parseResponse(
      await axiosInstance.delete(`${PWA_URL}/push-subscriptions`, {
        data: { endpoint },
      })
    );
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
